import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import $ from "jquery";
import React, { useEffect, useState } from 'react';
import { Button, Col, Badge, Container, Form, Row, Table } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import * as Common from "../Common";
import Dialog from '../Dialog';
import LoginHeader from '../Login_header';
import Menu from '../Menu';
import * as Picklist from '../Picklist';
import Tran_data_unlock_request from '../Tran_data_unlock_request';
import { faDownload } from '@fortawesome/free-solid-svg-icons/faDownload';


const Tran_opn_vtm_settlement = () => {

    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const branchDisable = sessionStorage.getItem('branchDisable');
    const [selectedValue, setSelectedValue] = useState(null);
    const [selectedCurrency, setSelectedCurrency] = useState(null);
    const [deno, setDeno] = useState("");
    const [selectedIssuer, setSelectedIssuer] = useState(null);
    const [userRight, setUserRight] = useState([]);
    const [onceRun, setOnceRun] = useState(false);
    const [vtmStList, setVtmStList] = useState([]);
    const [location, setLocation] = useState("");
    const [locationCode, setLocationCode] = useState("");
    const [showLocationForm, setLocationForm] = useState(true);
    const [showAddForm, setAddForm] = useState(false);
    const [quantity, setQuantity] = useState("1");
    const [rate, setRate] = useState("");
    const [amount, setAmount] = useState("");
    const [vtmFrom, setVtmFrom] = useState("");
    const [vtmTo, setVtmTo] = useState("");
    const [currencyCode, setCurrencyCode] = useState("");
    const [currency, setCurrency] = useState("");
    const [currencyType, setCurrencyType] = useState("1");
    const [prefix, setPrefix] = useState("");
    const [groupCode, setGroupCode] = useState("");
    const [accountCode, setAccountCode] = useState("");

    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");

    const [isErrBox, setErrBox] = useState(false);
    const [errText, setErrText] = useState("");

    const [viewDate, setViewDate] = useState('');
    const currentDate = new Date();

    const [showEditRequest, setShowEditRequest] = useState(false);
    const [editLogObject, setEditLogObject] = useState({ trantype: "", trannumber: "", location: "", entity_name: "", trandate: "", tdu_status: "" });
    const [isClickedUpload, setIsClickedUpload] = useState(false);
    const [vtmstFile, setVtmstFile] = useState('');
    const [unlockRequestType, setUnlockRequestType] = useState("");



    useEffect(() => {

        if (onceRun) {
            return;
        } else {
            if (sessionStorage.getItem("activeBranch") == Common.HoCode) {
                sessionStorage.activeBranch = sessionStorage.getItem('activeBranchWithoutHo');
            }
            Common.getActiveBranch().then(response => {
                setSelectedValue(response);
                response != null && handleChange(response);
            });
            Common.callApi(Common.apiRight, [sid, 'all', 'TRAN_OPN_VTM_SETTLEMENT'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/');
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    var msg = [], i = 0;
    const list = () => {
        if (selectedValue == null) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (selectedValue === null ? " Please select location." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        }
        else {
            setLocationForm(false)
            const loc = selectedValue.id.split('^');
            console.log(selectedValue);
            setLocationCode(loc[1]);
            setLocation(loc[2]);
            Common.callApi(Common.apiTranOpnVtmSt, [sid, 'listOpnVtm', loc[1]], (result) => {
                let resp = JSON.parse(result);
                console.log(resp);
                setVtmStList(resp);
            });
        }
    }

    const addCurrencyVtmSt = () => {

        if (deno === "" || selectedCurrency === null || rate === "" || quantity == "" || vtmFrom == "" || selectedIssuer == null) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (deno === "" ? " Please fill deno." : '');
            msg[i++] = (selectedCurrency === null ? " Please select currency." : '');
            msg[i++] = (rate === "" ? " Please fill rate." : '');
            msg[i++] = (quantity === "" ? " Please fill quantity." : '');
            msg[i++] = (vtmFrom === "" ? " Please fill from." : '');
            msg[i++] = (selectedIssuer === null ? " Please fill issuer." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            $('.loader').show();
            let obj = {};
            let grp = selectedIssuer.id.split('^');
            setGroupCode(grp[1]);
            setAccountCode(grp[2]);

            let curr = selectedCurrency.id.split('^');
            console.log(curr);
            setCurrencyCode(curr[1]);
            setCurrency(curr[2]);
            obj = {
                deno: deno,
                qty: quantity,
                rate: rate,
                amount: amount,
                from: vtmFrom,
                to: vtmTo,
                loc: locationCode,
                currency: curr[1],
                productType: 'OPNVTMST',
                product: 'VTM',
                prefix: prefix,
                groupCode: grp[1],
                accountCode: grp[2]
            }
            Common.callApi(Common.apiTranOpnVtmSt, [sid, 'addOpnVtm', JSON.stringify(obj)], (result) => {
                let resp = JSON.parse(result);
                console.log(resp);
                setVtmStList(resp)
                $('.loader').hide();
                setRate("");
                setAmount("");
                setPrefix("");
                setDeno("");
                setQuantity("");
                setVtmFrom("");
                setVtmTo("");
                setSelectedCurrency("");
                setSelectedIssuer("");
            });
            if (unlockRequestType !== "SELF") {
                const object = {
                    srno: 1,
                    type: 'OPNVTMST',
                    status: 'E',
                    currentDate: Common.dateYMD(currentDate),
                    pageright: 'TRAN_OPN_VTM_SETTLEMENT'
                }
                Common.callApi(Common.apiUnlockEdit, [sid, 'expireUnlock', JSON.stringify(object)], (result) => {
                    console.log(result);
                });
            }
        }
    }

    const handleChange = value => {
        setSelectedValue(value);
        var id = value.id;
        var location = id.split("^");
        sessionStorage.activeBranch = location[1];
    }

    const handleCurrencyChange = value => {
        setSelectedCurrency(value);
    }

    const handleIssuerChange = value => {
        setSelectedIssuer(value);
    }

    const handleBack = () => {
        if (showAddForm) {
            setAddForm(false);
        } else {
            setLocationForm(true);
            setVtmStList([]);
        }
    }

    const handleFrom = (e) => {
        Common.validateNumValue(e.target.value, setVtmFrom)
        if (e.target.value == "" || quantity == "") {
            setVtmTo("");
        } else {
            setVtmTo(1 * e.target.value - 1 + (1 * (quantity)));
        }
    }

    const handleQuantity = (e) => {
        if (e.target.value > 0 && e.target.value < 101) {
            Common.validateNumValue(e.target.value, setQuantity);
            if (vtmFrom == "" || e.target.value == "") {
                setVtmTo("");
            } else {
                setVtmTo(1 * vtmFrom - 1 + (1 * (e.target.value)));
            }
            calculateAmount(deno, e.target.value, rate)
        } else {
            setQuantity("");
            setErrText("Enter quantity greater than 0 and less than 101");
            setErrBox(true);
        }
    }

    const deleteItem = (id) => {
        Common.callApi(Common.apiTranOpnVtmSt, [sid, 'deleteOpnVtm', id, locationCode], (result) => {
            let resp = JSON.parse(result);
            console.log(resp);
            if (resp.msg == '') {
                setVtmStList(resp.optrial);
            }
            else {
                setErrText(resp.msg);
                setErrBox(true);
            }
        });
    }

    const calculateAmount = (deno, qty, rate) => {
        let number = deno * qty * rate;
        var roundedNumber = parseFloat(number.toFixed(2));
        setAmount(roundedNumber);
    }

    const handleDeno = (e) => {
        Common.validateDecValue(e.target.value, setDeno)
        calculateAmount(e.target.value, quantity, rate);
    }

    const handleRate = (e) => {
        Common.validateDecValue(e.target.value, setRate)
        calculateAmount(deno, quantity, e.target.value)
    }

    const btnEditRequest = () => {
        const currDate = new Date();
        const newDate = viewDate
        // .split('/');

        // const newViewDate = newDate[2] + '-' + newDate[1] + '-' + newDate[0]
        const newCurrDate = Common.dateYMD(currDate);

        const dateA = new Date(newDate);
        const dateB = new Date(newCurrDate);

        // Calculate the difference in milliseconds
        const differenceInMilliseconds = dateB - dateA;

        // Convert milliseconds difference to days
        const differenceInDays = Math.ceil(differenceInMilliseconds / (1000 * 3600 * 24));

        const locationCode = selectedValue.id.split("^")[1];

        const obj = {
            srno: 1,
            type: 'OPNVTMST',
            pageright: 'TRAN_OPN_VTM_SETTLEMENT',
            location: locationCode
        }
        // const message = 'unlock'
        Common.callApi(Common.apiUnlockEdit, [sid, 'checkUnlock', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setUnlockRequestType(resp.requestsrc);
            if (Common.editDateLimit == differenceInDays || resp.msg == "unlock") {
                setAddForm(true)
                makeVTMFormEmpty();
            } else {
                let res;
                Common.callApi(Common.apiUnlockEdit, [sid, 'getStatus', JSON.stringify(obj)], (result) => {
                    res = JSON.parse(result);
                    setEditLogObject({ trantype: 'OPNVTMST', trannumber: 1, location: locationCode, entity_name: location, tranDate: Common.dateYMD(currDate), tdu_status: res });
                    setShowEditRequest(true);
                })
            }
        })
    }

    function makeVTMFormEmpty() {
        setSelectedCurrency(null);
        setDeno('');
        setSelectedIssuer(null);
        setRate('');
        setQuantity(1);
        setPrefix('');
        setAmount('');
        setVtmFrom('');
        setVtmTo('');
    }

    const uploadBtn = () => {
        setIsClickedUpload(true);
        setVtmstFile(null);
    }

    function demovtmstformatfile() {
        $(".loader").show();
        const obj = {
            location: locationCode,
            pageright: 'TRAN_OPN_VTM_SETTLEMENT',
        }
        Common.callDownloadApiPost1(Common.apiTranOpnVtmSt, "post", [sid, 'downloadformat', JSON.stringify(obj)], (result) => {
            $(".loader").hide();
            setMsgText(Common.buildMessageFromArray([result]));
            setMsgBox(true);
        })
    }

    const uploadFile = () => {
        console.log(document.getElementById('fileExcel').files[0]);
        setVtmstFile(null);
        $('.loader').show();
        if (document.getElementById('fileExcel').files[0] === undefined) {
            $('.loader').hide();
            setMsgText("Please select a file to upload.");
            setMsgBox(true);
        } else {
            var tempArray = document.getElementById('fileExcel').files[0].name.split('.');
            if (tempArray.length > 2) {
                $('.loader').hide();
                setMsgText("(.) not allowed in file name.");
                setMsgBox(true);
            } else if (document.getElementById('fileExcel').files[0].size > 10 * 1024 * 1024) {  // 10 MB
                $('.loader').hide();
                setMsgText("Please select a file with in 10 MB size.");
                setMsgBox(true);
            } else if (tempArray[1] != 'xlsx') {
                $('.loader').hide();
                setMsgText("File extension should be in xlsx format");
                setMsgBox(true);
            } else {
                const obj = {
                    sid: sid,
                    vtmstFile: vtmstFile,
                    uploadType: "uploadVtmst",
                    pageright: "TRAN_OPN_VTM_SETTLEMENT",
                    loc: locationCode,
                }
                Common.uploadApi(JSON.stringify(obj), 'fileExcel', (result) => {
                    $('.loader').hide();
                    let resp = JSON.parse(result);
                    setMsgBox(true);
                    setMsgText(resp.msg);
                    setIsClickedUpload(false);
                    setVtmStList(resp.vtmstdata);
                });
            }
        }
    }


    return (
        <div>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h2>VTM SETTLEMENT</h2>
                    </Col>
                </Row>
                &nbsp;

                {
                    showLocationForm ? <>
                        <Row>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>Location<span className="text-danger">*</span></Form.Label>
                                    <AsyncSelect
                                        cacheOptions={false}
                                        defaultOptions={false}
                                        value={selectedValue}
                                        getOptionLabel={e => e.label + ' '}
                                        getOptionValue={e => e.id}
                                        loadOptions={Picklist.fetchLocationAllowedWithoutHoPicklist}
                                        onInputChange={Picklist.handleInputChange}
                                        onChange={handleChange}
                                        isDisabled={branchDisable === "true"}
                                    >
                                    </AsyncSelect>
                                </Form.Group>
                            </Col>
                        </Row>
                        &nbsp;
                        <Row>
                            <Col className='col-md-3 col-6'>
                                {
                                    userRight.query === "1" ?
                                        <Button variant='outline-success' className='buttonStyle' size='sm' onClick={list}>List</Button>
                                        : null}
                            </Col>
                        </Row>
                        &nbsp;
                    </> : <>
                        <Row>
                            <Col className='col-md-3 col-6'>
                                <Form.Label>Location : {location}</Form.Label>
                            </Col>
                        </Row>
                        &nbsp;
                        <Row>
                            <Col>
                                <Button variant='outline-danger' className='buttonStyle' size='sm' onClick={handleBack}>Back</Button>{' '}
                                {
                                    userRight.add === "1" && !showAddForm ?
                                        <>
                                            <Button variant='outline-success' className='buttonStyle' size='sm'
                                                onClick={() => btnEditRequest()}
                                            >Edit</Button>
                                        </>
                                        : null
                                }
                            </Col>
                        </Row>
                        &nbsp;
                    </>
                }
                {
                    showAddForm &&
                    <>
                        <Row>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>Issuer<span className="text-danger">*</span></Form.Label>
                                    <AsyncSelect
                                        cacheOptions
                                        defaultOptions
                                        value={selectedIssuer}
                                        getOptionLabel={e => e.label + ' '}
                                        getOptionValue={e => e.id}
                                        loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, 'ISSUER', locationCode)}
                                        onInputChange={Picklist.handleInputChange}
                                        onChange={handleIssuerChange}
                                    >
                                    </AsyncSelect>
                                </Form.Group>
                            </Col>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>Currency<span className="text-danger">*</span></Form.Label>
                                    <AsyncSelect
                                        cacheOptions
                                        defaultOptions
                                        value={selectedCurrency}
                                        getOptionLabel={e => e.label + ' '}
                                        getOptionValue={e => e.id}
                                        loadOptions={(search) => Picklist.fetchCurrencyAllowedPicklist(search, 'VTMST')} // location = 1 , 2
                                        onInputChange={Picklist.handleInputChange}
                                        onChange={handleCurrencyChange}
                                    >
                                    </AsyncSelect>
                                </Form.Group>
                            </Col>
                            <Row>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Denomination<span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            value={deno}
                                            onChange={(e) => handleDeno(e)}
                                            // setPrefix(e.target.value)}
                                            maxLength={Common.maximumLength}
                                            placeholder="Deno" />
                                    </Form.Group>
                                </Col>

                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Rate<span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            value={rate}
                                            onChange={(e) => handleRate(e)}
                                            maxLength={Common.rateMaxLength}
                                            placeholder="Rate" />
                                    </Form.Group>
                                </Col>
                                {/* <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>Quantity<span className="text-danger">*</span></Form.Label>
                                    <Form.Control
                                        value={quantity}
                                        onChange={(e) => handleQuantity(e)}
                                        maxLength={Common.maximumLength}
                                        placeholder="Quantity" />
                                </Form.Group>
                            </Col> */}
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Amount<span className="text-danger"></span></Form.Label>
                                        <Form.Control
                                            value={amount}
                                            disabled
                                            maxLength={Common.maximumLength}
                                            placeholder="Amount" />
                                    </Form.Group>
                                </Col>
                                {/* <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>Prefix</Form.Label>
                                    <Form.Control
                                        value={prefix}
                                        onChange={(e) => Common.validateAlpNumValue(e.target.value, setPrefix)}
                                        maxLength={Common.prefixLength}
                                        placeholder="Prefix" />
                                </Form.Group>
                            </Col> */}
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>From<span className="text-danger">*</span></Form.Label><br />
                                        <Form.Control
                                            value={vtmFrom}
                                            onChange={(e) => handleFrom(e)}
                                            maxLength={Common.maxFromLength}
                                            placeholder="From" />
                                    </Form.Group>
                                </Col>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>To</Form.Label>
                                        <Form.Control
                                            value={vtmTo}
                                            disabled
                                            placeholder="To" />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Row>
                        &nbsp;
                        <Row>
                            <Col>
                                <Button variant='outline-success' className='buttonStyle' size='sm' onClick={addCurrencyVtmSt} >Add</Button>{' '}
                                {!isClickedUpload && <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => uploadBtn()}>Upload</Button>}&nbsp;
                            </Col>
                        </Row>
                        &nbsp;

                        <Row>&nbsp;</Row>
                        {
                            isClickedUpload &&
                            <>
                                <Row>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group controlId="fileExcel">
                                            <Form.Label>Choose File<span className="text-danger">*</span></Form.Label>
                                            <Form.Control type="file" value={vtmstFile} onChange={(e) => setVtmstFile(e.target.value)} />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>&nbsp;</Row>
                                <Row>
                                    <Col>
                                        <span>
                                            <Badge bg="secondary" className="handCursor" onClick={demovtmstformatfile}>Vtmst Format <FontAwesomeIcon icon={faDownload} /></Badge>
                                        </span><br></br> <br></br>
                                        <Button variant="outline-success" className='buttonStyle' size='sm' onClick={() => uploadFile()} >Upload</Button>{' '}
                                    </Col>
                                </Row>
                            </>
                        }
                        <Row>&nbsp;</Row>
                    </>
                }
                {!showLocationForm &&
                    <Row>
                        <Col>
                            <Table striped bordered hover size="sm">
                                <thead>
                                    <tr>
                                        {userRight.edit === "1" ? <th></th> : null}
                                        {/* <th>Sr No</th> */}
                                        <th>ISD</th>
                                        {/* <th>Prefix</th> */}
                                        <th>Issuer Name</th>
                                        <th style={{ textAlign: 'right' }}>Deno</th>
                                        {/* <th style={{ textAlign: 'right' }}>Quantity</th> */}
                                        <th style={{ textAlign: 'right' }}>Rate</th>
                                        <th style={{ textAlign: 'right' }}>Amount</th>
                                        <th style={{ textAlign: 'right' }}>From</th>
                                        <th style={{ textAlign: 'right' }}>To</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {vtmStList.map((res) =>
                                        <tr key={res.prd_line_no}>
                                            {userRight.delete === "1" ?
                                                <td className="textCenter" >
                                                    {
                                                        showAddForm &&
                                                        <span className="handCursor" onClick={() => deleteItem(res.line)} >
                                                            <div className="colorThemeBlue"><FontAwesomeIcon icon={faTrash} /></div>
                                                        </span>
                                                    }
                                                </td>
                                                : null
                                            }
                                            {/* <td>{res.prd_line_no}</td> */}
                                            <td>{res.prd_isd}</td>
                                            {/* <td>{res.prd_prefix}</td> */}
                                            <td>{res.mvli_ledger_name}</td>
                                            <td style={{ textAlign: 'right' }}>{res.prd_deno}</td>
                                            {/* <td style={{ textAlign: 'right' }}>{res.prd_qty}</td> */}
                                            <td style={{ textAlign: 'right' }}>{res.prd_rate}</td>
                                            <td style={{ textAlign: 'right' }}>{res.prd_amount}</td>
                                            <td style={{ textAlign: 'right' }}>{res.prd_from}</td>
                                            <td style={{ textAlign: 'right' }}>{res.prd_to}</td>
                                        </tr>
                                    )
                                    }
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                }
            </Container>

            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
                <Dialog isOpen={isErrBox} onClose={(e) => setErrBox(false)}>
                    {errText}
                </Dialog>
                <Tran_data_unlock_request logObject={editLogObject} show={showEditRequest} hdrNotExist={true} onHide={() => setShowEditRequest(false)} />
            </div>
            <Row> &nbsp;</Row>
            <Row> &nbsp;</Row>
            <Row> &nbsp;</Row>
            <Row> &nbsp;</Row>
            <Row> &nbsp;</Row>
            <Row> &nbsp;</Row>
            <Row> &nbsp;</Row>
        </div>
    )
}

export default Tran_opn_vtm_settlement
